import { render, staticRenderFns } from "./InviteDetailModal.vue?vue&type=template&id=5a70afb0&scoped=true&"
import script from "./InviteDetailModal.vue?vue&type=script&lang=js&"
export * from "./InviteDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteDetailModal.vue?vue&type=style&index=0&id=5a70afb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70afb0",
  null
  
)

export default component.exports